import { visitorIdentityForThisPage } from "cookiesConsent/infrastructure/segment/visitorIdentityForThisPage"

export const forgetVisitor = (): void => {
  visitorIdentityForThisPage().forget()
}
